unit uSpravaOtazok;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.DataGrid.Common, WEBLib.Buttons, WEBLib.ExtCtrls, Vcl.Grids,
  WEBLib.DataGrid, WEBLib.REST, WEBLib.JSON, System.NetEncoding;

type
  TfSpravaOtazok = class(TForm)
    WebDataGrid1: TDataGrid;
    WebPanel1: TPanel;
    lPredmet: TLabel;
    sbNovy: TSpeedButton;
    sbEdit: TSpeedButton;
    btnZmazat: TSpeedButton;
    sbNavrat: TSpeedButton;
    procedure WebFormShow(Sender: TObject);
    [async]
    procedure sbNovyClick(Sender: TObject); async;
    [async]
    procedure btnZmazatClick(Sender: TObject); async;
    [async]
    procedure sbEditClick(Sender: TObject); async;
    procedure sbNavratClick(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    VybranyPredmet: string; // Tu bude zapísané 'Biologia' alebo 'Chemia'
    [async]
    procedure NacitajZoznamOtazok; async;
//    procedure SkoorujNaOtazku(ACisloOtazky: integer; ANoVa: boolean);
  protected procedure LoadDFMValues; override; end;

var
  fSpravaOtazok: TfSpravaOtazok;

implementation

{$R *.dfm}

uses uEditOtazky;


[async]
[async]
procedure TfSpravaOtazok.btnZmazatClick(Sender: TObject); async;
var
  wr: THttpRequest;
  res: TJSXMLHttpRequest;
  ZvolenyRiadok, IDOtazky: integer;
begin
  // 1. Tvoj overený spôsob získania indexu označeného riadku
  ZvolenyRiadok := WebDataGrid1.FindFirstSelectedRowIndex;
  if ZvolenyRiadok < 0 then
  begin
    ShowMessage('Najskôr kliknutím vyber otázku, ktorú chceš zmazať.');
    Exit;
  end;
  // 2. Bezpečnostná otázka
  if await(TModalResult, MessageDlgAsync('Naozaj chceš natvrdo zmazať vybranú otázku vrátane všetkých jej odpovedí?',
     mtConfirmation, [mbYes, mbNo])) = mrYes then
  begin
    // 3. Vytiahneme ID otázky z pôvodného JSON objektu riadku
    try
      IDOtazky := StrToIntDef(WebDataGrid1.AllCells[ZvolenyRiadok, 3], 0);
    except
      IDOtazky := 0;
    end;
    if IDOtazky = 0 then
    begin
      ShowMessage('Nepodarilo sa overiť ID zvolenej otázky.');
      Exit;
    end;
    // 4. Odoslanie požiadavky na server
    wr := THttpRequest.Create(nil);
    try
      wr.Command := httpPOST;
      wr.URL := 'http://' + window.location.hostname + ':8080/zmazatotazku';
      wr.PostData := '{"OTAZKA_ID":"' + IntToStr(IDOtazky) + '"}';
      res := await(TJSXMLHttpRequest, wr.Perform);
      if (res <> nil) and (res.status = 200) then
      begin
        ShowMessage('Otázka bola úspešne vymazaná z databázy.');
        // 5. Ihneď znova načítame Grid
        NacitajZoznamOtazok;
      end
      else
        ShowMessage('Chyba: Server nedokázal otázku vymazať.');
    finally
      wr.Free;
    end;
  end;
end;


[async]
procedure TfSpravaOtazok.NacitajZoznamOtazok; async;
var
  wr: THttpRequest;
  res: TJSXMLHttpRequest;
  DataObject: TJSObject;
  CistyJsonText, FilterPayload: string;
begin
  // Poskladáme filter pre hľadanie
  FilterPayload := '{"PREDMET":"' + VybranyPredmet + '"}';
  wr := THttpRequest.Create(nil);
  try
    wr.Command := httpPOST;
    wr.URL := 'http://' + window.location.hostname + ':8080/zoznamotazok';
    // Zašifrujeme aj odchádzajúci dopyt do Base64 s diakritikou (pre istotu)
    asm
      var utf8Bytes = encodeURIComponent(FilterPayload).replace(/%([0-9A-F]{2})/g, function(match, p1) {
          return String.fromCharCode('0x' + p1);
      });
      wr.FPostData = btoa(utf8Bytes);
    end;
    res := await(TJSXMLHttpRequest, wr.Perform);
    if (res <> nil) and (res.responseText <> '') then
    begin
      // 🔥 DEŠIFROVANIE Z BASE64 DO ČISTÉHO SLOVENSKÉHO UTF-8 TEXTU:
      asm
        var binaryString = atob(res.responseText);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        var decoder = new TextDecoder('utf-8');
        CistyJsonText = decoder.decode(bytes);
      end;
      // Naplníme tvoj Grid z dešifrovaného čistého JSON textu
      DataObject := TJSObject(Pointer(TJSJSON.parse(CistyJsonText)));

      WebDataGrid1.Theming.ThemeMode := agLightMode;
//      WebDataGrid1.Theming.ThemeMode := agDarkMode;
      WebDataGrid1.Theming.Enabled := TRUE;
      WebDataGrid1.Theming.ApplyChanges;
      WebDataGrid1.LoadFromJSON(DataObject);
      WebDataGrid1.Visible := True;
    end;
  finally
    wr.Free;
  end;
end;



procedure TfSpravaOtazok.sbEditClick(Sender: TObject);
var
  FormEdit: TfEditOtazky;
  ZvolenyRiadok: integer;
begin
  // 1. Zistíme index označeného riadku z tvojho tmavého gridu
  ZvolenyRiadok := WebDataGrid1.FindFirstSelectedRowIndex;
  if ZvolenyRiadok < 0 then
  begin
    ShowMessage('Najskôr kliknutím vyber otázku, ktorú chceš opraviť.');
    Exit;
  end;
  // 2. Vytvoríme formulár presne v tvojom dizajnovom štýle
  FormEdit := TfEditOtazky.Create(Self);
  FormEdit.VybranyPredmet := VybranyPredmet;
  FormEdit.Popup := False;
  FormEdit.Border := fbNone;
  // 3. NASTAVÍME REŽIM OPRAVY (tvoj vzor)
  FormEdit.otazkanova := False;
  // 4. Vytiahneme skryté ID z tabuľky (stĺpec 3) a pošleme ho do vnútra okna fEditOtazky
  FormEdit.OtazkaID := StrToIntDef(WebDataGrid1.AllCells[ZvolenyRiadok, 3], 0);
  // 5. Asynchrónne načítanie a spustenie formulára
  await(TfEditOtazky, FormEdit.Load);
  if await(TModalResult, FormEdit.Execute) = mrOk then
  begin
    // Ak admin zmeny uložil, ihneď grid nanovo načítame, aby preklep zmizol!
    NacitajZoznamOtazok;
  end;
  FormEdit.Free;
end;


procedure TfSpravaOtazok.sbNavratClick(Sender: TObject);
begin
ModalResult := mrOk;
end;

procedure TfSpravaOtazok.sbNovyClick(Sender: TObject);
var
  FormEdit: TfEditOtazky;
begin
  FormEdit := TfEditOtazky.Create(Self);
  FormEdit.VybranyPredmet := VybranyPredmet; // Odovzdáme predmet (Biologia/Chemia)
  FormEdit.Popup := False;
  FormEdit.Border := fbNone;
  FormEdit.otazkanova := true;


  await(TfEditOtazky, FormEdit.Load);
  if await(TModalResult, FormEdit.Execute) = mrOk then
  begin
    // Ak sa otázka úspešne uložila, hneď znova načítame tabuľku, aby sa tam objavila!
    NacitajZoznamOtazok;
  end;
  FormEdit.Free;
end;




procedure TfSpravaOtazok.WebFormShow(Sender: TObject);
begin
lPredmet.Caption := VybranyPredmet;
NacitajZoznamOtazok;

end;



{procedure TForm1.SkoorujNaOtazku(ACisloOtazky: integer; ANoVa: boolean);
var
  i: integer;
  NajdenyRiadok: integer;
begin
  NajdenyRiadok := -1;
  // Ak je to nová otázka, skočíme rovno na úplný koniec gridu
  if ANoVa then
  begin
    WebDataGrid1.RowIndex := WebDataGrid1.Rows.Count - 1;
    Exit;
  end;
  // Ak opravujeme, prejdeme grid a nájdeme riadok s naším číslom otázky
  // V TWebDataGrid sa pristupuje: cells[stlpoc][riadok]
  for i := 0 to WebDataGrid1.Rows.Count - 1 do
  begin
    if StrToIntDef(WebDataGrid1.Cells[1][i], -1) = ACisloOtazky then
    begin
      NajdenyRiadok := i;
      break;
    end;
  end;
  // Ak sme otázku v zozname našli, aktivujeme jej riadok
  if NajdenyRiadok <> -1 then
  begin
    WebDataGrid1.RowIndex := NajdenyRiadok;
  end;
end;

 }


procedure TfSpravaOtazok.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebDataGrid1 := TDataGrid.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  lPredmet := TLabel.Create(Self);
  sbNovy := TSpeedButton.Create(Self);
  sbEdit := TSpeedButton.Create(Self);
  btnZmazat := TSpeedButton.Create(Self);
  sbNavrat := TSpeedButton.Create(Self);

  WebDataGrid1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  lPredmet.BeforeLoadDFMValues;
  sbNovy.BeforeLoadDFMValues;
  sbEdit.BeforeLoadDFMValues;
  btnZmazat.BeforeLoadDFMValues;
  sbNavrat.BeforeLoadDFMValues;
  try
    Name := 'fSpravaOtazok';
    Width := 1035;
    Height := 752;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebDataGrid1.SetParentComponent(Self);
    WebDataGrid1.Name := 'WebDataGrid1';
    WebDataGrid1.Left := 150;
    WebDataGrid1.Top := 0;
    WebDataGrid1.Width := 885;
    WebDataGrid1.Height := 752;
    WebDataGrid1.TabStop := False;
    WebDataGrid1.Banding.Enabled := False;
    WebDataGrid1.Banding.OddRowsColor := 16777215;
    WebDataGrid1.Banding.EvenRowsColor := 16777215;
    WebDataGrid1.Theming.ThemeMode := agDarkMode;
    WebDataGrid1.MaxBlocksInCache := 0;
    WebDataGrid1.TabOrder := 0;
    WebDataGrid1.RowMultiSelectWithClick := False;
    WebDataGrid1.EnableClickSelection := True;
    WebDataGrid1.BidiMode := bdLeftToRight;
    WebDataGrid1.SuppressMoveWhenColumnDragging := False;
    WebDataGrid1.Align := alClient;
    WebDataGrid1.ColumnDefs.Clear;
    with WebDataGrid1.ColumnDefs.Add do
    begin
      Field := 'ROZSAH';
      CellDataType := cdtText;
      HeaderName := 'ROZSAH';
      CheckboxSelection := False;
      Width := 134;
    end;
    with WebDataGrid1.ColumnDefs.Add do
    begin
      Field := 'CISLO_OTAZKY';
      CellDataType := cdtText;
      HeaderName := #268#205'SLO OT'#193'ZKY';
      CheckboxSelection := False;
      Width := 145;
    end;
    with WebDataGrid1.ColumnDefs.Add do
    begin
      Field := 'TEXT_OTAZKY';
      CellDataType := cdtText;
      HeaderName := 'OT'#193'ZKA';
      CheckboxSelection := False;
      Width := 1000;
    end;
    with WebDataGrid1.ColumnDefs.Add do
    begin
      Field := 'OTAZKA_ID';
      CellDataType := cdtText;
      CheckboxSelection := False;
      Visible := False;
    end;
    WebDataGrid1.Visible := False;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 150;
    WebPanel1.Height := 752;
    WebPanel1.Align := alLeft;
    WebPanel1.ChildOrder := 4;
    WebPanel1.Color := 16765066;
    WebPanel1.TabOrder := 1;
    lPredmet.SetParentComponent(WebPanel1);
    lPredmet.Name := 'lPredmet';
    lPredmet.Left := 15;
    lPredmet.Top := 24;
    lPredmet.Width := 121;
    lPredmet.Height := 33;
    lPredmet.Alignment := taCenter;
    lPredmet.AutoSize := False;
    lPredmet.Caption := 'lPredmet';
    lPredmet.Font.Charset := DEFAULT_CHARSET;
    lPredmet.Font.Color := clWhite;
    lPredmet.Font.Height := -16;
    lPredmet.Font.Name := 'Segoe UI';
    lPredmet.Font.Style := [];
    lPredmet.HeightPercent := 100.000000000000000000;
    lPredmet.ParentFont := False;
    lPredmet.WidthPercent := 100.000000000000000000;
    sbNovy.SetParentComponent(WebPanel1);
    sbNovy.Name := 'sbNovy';
    sbNovy.Left := 15;
    sbNovy.Top := 63;
    sbNovy.Width := 121;
    sbNovy.Height := 41;
    sbNovy.Caption := 'Nov'#225' ot'#225'zka';
    sbNovy.Color := 16763647;
    sbNovy.HeightPercent := 100.000000000000000000;
    sbNovy.TabOrder := 0;
    sbNovy.WidthPercent := 100.000000000000000000;
    SetEvent(sbNovy, Self, 'OnClick', 'sbNovyClick');
    sbEdit.SetParentComponent(WebPanel1);
    sbEdit.Name := 'sbEdit';
    sbEdit.Left := 15;
    sbEdit.Top := 110;
    sbEdit.Width := 121;
    sbEdit.Height := 41;
    sbEdit.Caption := 'Oprava ot'#225'zky';
    sbEdit.Color := 16763647;
    sbEdit.HeightPercent := 100.000000000000000000;
    sbEdit.TabOrder := 1;
    sbEdit.WidthPercent := 100.000000000000000000;
    SetEvent(sbEdit, Self, 'OnClick', 'sbEditClick');
    btnZmazat.SetParentComponent(WebPanel1);
    btnZmazat.Name := 'btnZmazat';
    btnZmazat.Left := 15;
    btnZmazat.Top := 157;
    btnZmazat.Width := 121;
    btnZmazat.Height := 41;
    btnZmazat.Caption := 'Vymaza'#357' ot'#225'zku';
    btnZmazat.Color := 16763647;
    btnZmazat.HeightPercent := 100.000000000000000000;
    btnZmazat.TabOrder := 2;
    btnZmazat.WidthPercent := 100.000000000000000000;
    SetEvent(btnZmazat, Self, 'OnClick', 'btnZmazatClick');
    sbNavrat.SetParentComponent(WebPanel1);
    sbNavrat.Name := 'sbNavrat';
    sbNavrat.Left := 15;
    sbNavrat.Top := 239;
    sbNavrat.Width := 121;
    sbNavrat.Height := 41;
    sbNavrat.Caption := 'N'#225'vrat';
    sbNavrat.Color := 16763647;
    sbNavrat.HeightPercent := 100.000000000000000000;
    sbNavrat.TabOrder := 3;
    sbNavrat.WidthPercent := 100.000000000000000000;
    SetEvent(sbNavrat, Self, 'OnClick', 'sbNavratClick');
  finally
    WebDataGrid1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    lPredmet.AfterLoadDFMValues;
    sbNovy.AfterLoadDFMValues;
    sbEdit.AfterLoadDFMValues;
    btnZmazat.AfterLoadDFMValues;
    sbNavrat.AfterLoadDFMValues;
  end;
end;

end.